import { Typography } from "antd";
import brandData from "@/assets/brand.json"

const { Title } = Typography;

export const onboardingItems = [
  {
    illustration:
      <>
        <Title style={{ textAlign: "center" }} level={2}>Estás entrando a</Title>
        <div style={{ padding: "32px 0 32px 0" }}>
          <img src='/logo-light.svg' alt='app logo' style={{ marginLeft: "auto", width: "100%", maxHeight: "64px" }} />
        </div>
      </>
    ,
    message: <>Un espacio independiente de <b>{brandData.main.name}</b> donde podrás recibir beneficios únicos al probar nuevas funciones.</>
  },
  {
    illustration: <img src='/onboarding/illustration-missions.svg' alt='Misiones' />,
    message: <><b>Participa en las misiones</b> de redes sociales y encuestas.</>
  },
  {
    illustration: <img src='/onboarding/illustration-coins.svg' alt={brandData.pages.wallet.currencies[0].title} />,
    message: <><b>Gana {brandData.pages.wallet.currencies[0].title}</b> por responder en cada una de la misiones y/o encuestas.</>
  },
  {
    illustration: <img src='/onboarding/illustration-exchange.svg' alt='Canjeo' />,
    message: <>¡<b>Canjea tus {brandData.pages.wallet.currencies[0].title}</b> por recompensas increíbles!</>
  },
]